export default "__VITE_ASSET__BIrNFwxc__"